import { TokenVerifyResponse } from '@/types/user'
import { apiClient } from '../axios'
import { tokenStore } from '../tokenStore'

export type { TokenVerifyResponse }

// Requests can stall silently in in-app browsers (e.g. WhatsApp); the timeout
// rejects instead of leaving the caller stuck on the sign-in spinner forever.
const VERIFY_TIMEOUT_MS = 20000

export const postTokenVerify = async (
  token: string,
): Promise<TokenVerifyResponse> => {
  const response = await apiClient.post<TokenVerifyResponse>(
    'upauth/token/verify',
    { token },
    { timeout: VERIFY_TIMEOUT_MS },
  )
  tokenStore.set(response.data.access)
  return response.data
}
